module.exports = __webpack_public_path__ + "static/media/main idea.bf09467d.mp3";